/**
 * The Zest Assure citrus-slice mark, extracted from media/zestassure.svg
 * (paths only — the wordmark in that file uses a licensed font, so pages
 * render "Zest Assure" as styled text next to this mark instead).
 */

const STOPS = (
  <>
    <stop offset="0" stopColor="#f6851f" />
    <stop offset=".2" stopColor="#f47d20" />
    <stop offset=".5" stopColor="#f37221" />
    <stop offset=".9" stopColor="#f26722" />
    <stop offset="1" stopColor="#f05423" />
  </>
);

const GRADIENTS: Array<{ id: string; x1: number; y1: number; x2: number; y2: number }> = [
  { id: 'za-mark-g0', x1: 387.1, y1: 126.5, x2: 883.2, y2: 126.5 },
  { id: 'za-mark-g1', x1: 662, y1: 152.1, x2: 811.7, y2: 152.1 },
  { id: 'za-mark-g2', x1: 459.8, y1: 152, x2: 609.3, y2: 152 },
  { id: 'za-mark-g3', x1: 572.3, y1: 133, x2: 698.4, y2: 133 },
  { id: 'za-mark-g4', x1: 685, y1: 221.8, x2: 833.1, y2: 221.8 },
  { id: 'za-mark-g5', x1: 437, y1: 221, x2: 586.3, y2: 221 },
  { id: 'za-mark-g6', x1: 608.2, y1: 264.9, x2: 660.3, y2: 264.9 },
];

const PATHS = [
  'M866.6,252.8c-3.5,0-7-.2-10.5,0-4.7.4-6-1.9-6-6.2,0-7.8,0-15.6-1-23.3-1.5-10.7-3.2-21.4-6.2-31.8-8.3-29.6-21.5-56.9-41.5-80.6-34.5-40.9-77.9-66.7-130.8-75.2-15.5-2.5-31.5-3.6-47.1-2.7-48,2.6-90.6,19.8-127.4,50.9-23,19.4-41,42.8-54.3,69.6-10.3,20.7-17.1,42.6-19.7,65.7-1,9-1.6,18.1-1.9,27.2-.1,4.7-1.7,6.6-6.5,6.4-7.2-.3-14.3-.2-21.5,0-4,.1-5.2-1.4-5.2-5.3,0-27.6,4.6-54.3,13.4-80.4,8.8-26.1,21.6-50,38.5-71.5,24.7-31.6,55-56.4,91.7-73.1,21.9-10,44.7-17.2,68.7-19.8,13.7-1.5,27.5-3,41.2-2.8,33,.7,64.9,7.6,95.2,21,32.7,14.5,60.8,35.2,84.7,61.7,20.9,23.1,36.5,49.6,47.5,78.8,7.2,19.1,11.7,38.9,14,59.2,1,9.2.8,18.6,1.2,27.9.1,3.3-1.5,4.4-4.6,4.3-4-.1-8,0-12,0Z',
  'M811.7,164.1c0,5.4-3.6,7.4-7.6,9.1-13.6,5.5-27.2,10.9-40.7,16.4-29.1,11.9-58.2,23.7-87.3,35.7-4.2,1.7-8.1,2.3-11.6-1.1-3.5-3.5-2.8-7.6-1.1-11.6,17.8-42.3,35.7-84.6,53.5-126.8,3.7-8.8,7.5-10.2,15.9-5.5,33.2,18.6,58.7,45,77,78.3.9,1.7,1.3,3.7,1.9,5.6Z',
  'M609.3,216.8c-.1,8-5.8,11.5-12.8,8.8-11.1-4.4-22.2-9-33.2-13.6-31.8-13.1-63.7-26.2-95.5-39.3-8.2-3.4-9.9-7.4-5.6-15.1,18.1-32.9,43.4-58.7,76.1-77.2,9.1-5.1,13-3.7,17,5.8,17.4,41.6,34.9,83.1,52.2,124.7.9,2.3,1.5,4.7,1.9,5.9Z',
  'M601.2,58.1c13-2.6,26.3-3.9,39.5-3.4,0,0,.1,0,.2,0,16.6.6,33.1,2.6,49.1,7.2,7.7,2.2,10.2,7.1,7.1,14.5-17.2,42-34.4,84-51.7,126-.1.3-.3.6-.4.9-1.7,4.2-4.5,8.1-9.2,8-4.8,0-7.8-3.9-9.7-8.3-4.9-11.5-10-22.9-14.8-34.4-12.6-30.2-25-60.5-37.5-90.8-3.7-8.9-1.5-13.6,7.9-15.7,6.4-1.5,12.9-2.8,19.3-4.1Z',
  'M759.2,253.6c-22.1,0-44.3,0-66.4,0-3.5,0-6.8-.5-7.6-4.7-.8-4.1,1.8-5.8,5.2-7.2,40-16.3,80-32.6,120.1-48.9,11.4-4.6,13.4-4,16,8.1,2.6,12.1,3.9,24.4,5.8,36.6.4,2.8.9,5.5,1,8.3.1,6.2-1.5,7.8-7.5,7.8-11,0-22,0-33,0-11.2,0-22.3,0-33.5,0h0Z',
  'M511.7,253c-21.8,0-43.6-.4-65.4,0-7.9.1-10-3.3-9.1-10.4,1.2-9.8,2.5-19.5,4.1-29.2,1-5.8,2.4-11.5,4.2-17.1,2.4-7.7,4.7-8.6,12.2-5.5,12.6,5.2,25.2,10.3,37.9,15.5,27.7,11.4,55.4,22.7,83.1,34.1,1.1.4,2.2.9,3.2,1.4,2.8,1.5,5.1,3.5,4.3,7.1-.8,3.7-3.6,4.2-6.9,4.2-22.5,0-45,0-67.5,0,0,0,0,0,0,0Z',
  'M634.6,302.1c-15.1,0-26.4-33.3-26.4-48.2,0-14.4,11.6-26.1,25.9-26.2,14.9,0,26.3,11.3,26.3,26.1,0,14.9-11,25.9-25.7,26',
];

export function ZestMark({ className }: { className?: string }) {
  return (
    <svg viewBox="386 0 498 303" className={className} aria-hidden="true" focusable="false">
      <defs>
        {GRADIENTS.map((g) => (
          <linearGradient
            key={g.id}
            id={g.id}
            x1={g.x1}
            y1={g.y1}
            x2={g.x2}
            y2={g.y2}
            gradientUnits="userSpaceOnUse"
          >
            {STOPS}
          </linearGradient>
        ))}
      </defs>
      {PATHS.map((d, i) => (
        <path key={i} d={d} fill={`url(#za-mark-g${i})`} />
      ))}
    </svg>
  );
}
